export const REASONS_FOR_SUPPORT_CONTACT = [
  { value: '', text: 'Select a contact reason' },
  { value: 'upgrade', text: 'I want to upgrade to Pro' },
  { value: 'evangelist', text: 'I want to become an Evangelist' },
  { value: 'profile', text: 'I need help with my profile or have other questions' },
  { value: 'findCoach', text: 'I want to find a coach' },
  { value: 'joinCoach', text: 'I want to join as a coach' },
  { value: 'technical', text: 'I`m having technical difficulties' },
  { value: 'other', text: 'Other' },
];
